
export const VALIDATION_ZONES = {
	PAYMENT: 1,
	SHIPPING: 2,
	EMAIL: 3,
};

export const isValidCardNumber = (val) => {
	// remove spaces and dashes
	val = val.replace(/-|\s/g,"");

	if (/[^0-9-\s]+/.test(val)) return false;

	const luhnChk = ((arr) => {
		return (ccNum) => {
			let
				len = ccNum.length,
				bit = 1,
				sum = 0,
				val;

			while (len) {
				val = parseInt(ccNum.charAt(--len), 10);
				// eslint-disable-next-line no-cond-assign
				sum += (bit ^= 1) ? arr[val] : val;
			}

			return sum && sum % 10 === 0;
		};
	})([0, 2, 4, 6, 8, 1, 3, 5, 7, 9]);

	return luhnChk(val);
};

// eslint-disable-next-line no-useless-escape
const nameRe = /[!$%^&*()_+|~=`{}\[\]:";<>?,\/]/;
export const isValidNamePart = (val="") => !!val.trim() && !nameRe.test(val);
export const isValidFullName = (val) => (/^.+ .+.*$/).test(val);
export const isValidCvc = (val) => (/^\d+$/).test(val);
export const isValidExp = (year, month) => {
	const now = new Date();
	const curDate = new Date(now.getFullYear(), now.getMonth());
	const curTime = curDate.getTime();

	const expDate = new Date(year, +month - 1);
	const expTime = expDate.getTime();

	return expTime >= curTime;
};

/**
 * @param {Object}
 * @return {Bool}
 */
export const validPayment = ({
	customerPay={},
	walletEntryId=null,
	nonStripe=true,
	samePaymentAddress=true,
}) => {
	if (walletEntryId) {
		return true;
	}

	const {
		name,
		number,
		expMonth,
		expYear,
		cvc,
		zipCode,
		country,
	} = customerPay;

	// Disregard CardNumber, Cvc, Exp when using stripeElements
	if (nonStripe) {
		if (!isValidCardNumber(number)) {
			return false;
		}

		if (!isValidCvc(cvc)) {
			return false;
		}

		if (!isValidExp(expYear, expMonth)) {
			return false;
		}
	}

	// Disgregard when 'same as billing' checked - this isnt visible to user
	// (validate billing instead)
	if (!samePaymentAddress) {
		if (!isValidFullName(name)) {
			return false;
		}
		if (!zipCode || !country) {
			return false;
		}
	}

	return true;
};


/**
 * @param {Object}
 * @return {Bool}
 */
export const validShipAddress = ({
	shipAddress={},
	shipAddressId=null,
}) => {
	if (shipAddressId) {
		return true;
	}

	const {
		firstName,
		lastName,
		city,
		country,
		state,
		zipCode,
		street,
	} = (shipAddress || {});

	if (!isValidNamePart(firstName)) {
		return false;
	}

	if (!isValidNamePart(lastName)) {
		return false;
	}

	if (!city || !state || !zipCode || !country || !street) {
		return false;
	}

	return true;
};
